import API from "./api";

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`
});

// ======================
// PDF
// ======================
export const downloadPDF = async (params) => {
  const res = await API.get("/export/pdf", {
    params,
    responseType: "blob",
    headers: authHeader()
  });

  return res.data;
};

// ======================
// EXCEL
// ======================
export const downloadExcel = async (params) => {
  const res = await API.get("/export/excel", {
    params,
    responseType: "blob",
    headers: authHeader()
  });

  return res.data;
};

// ======================
// EMAIL
// ======================
export const sendReportEmail = async (payload) => {
  const res = await API.post("/export/email", payload, {
    headers: authHeader()
  });

  return res.data;
};